// src/components/dashboard/cases/newCase/case_id/caseTable/components/HelpOverlay.js
import React from "react";

const HelpOverlay = ({
  sectionDrawMode,
  isMulti,
  measureMode,
  showCrossSection,
}) => {
  return (
    <div className="stl-help-overlay">
      {sectionDrawMode ? (
        <>
          <span className="stl-help-key">Left drag</span> draw section line
        </>
      ) : (
        <>
          <span className="stl-help-key">Right drag</span> rotate
          <span className="stl-help-sep">·</span>
          <span className="stl-help-key">Scroll</span> zoom
          {!isMulti && (
            <>
              <span className="stl-help-sep">·</span>
              <span className="stl-help-key">Shift + right drag</span> orbit camera
            </>
          )}
          {isMulti && !measureMode && (
            <>
              <span className="stl-help-sep">·</span>
              <span className="stl-help-key">Left drag on model</span> move it
              <span className="stl-help-sep">·</span>
              <span className="stl-help-key">Right drag on model</span> rotate it
              <span className="stl-help-sep">·</span>
              <span className="stl-help-key">Shift + right drag</span> rotate all
              <span className="stl-help-sep">·</span>
              <span className="stl-help-key">Alt + drag</span> single file
            </>
          )}
          {measureMode && (
            <>
              <span className="stl-help-sep">·</span>
              <span className="stl-help-key">Left click</span> measure
            </>
          )}
          {showCrossSection && (
            <>
              <span className="stl-help-sep">·</span>
              <span className="stl-help-key">2D: wheel</span> zoom
              <span className="stl-help-sep">·</span>
              <span className="stl-help-key">right-drag</span> pan
            </>
          )}
        </>
      )}
    </div>
  );
};

export default HelpOverlay;